











































































































































































































































































































































































































































































































import { Component, Prop, Vue, Watch, Inject } from 'vue-property-decorator';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { User, UserConf, UserTime } from '@/data/models/user.model';
import { CrudService } from '@/data/services/crud.service';
import { Search } from '@/data/models/search.model';
import { Page } from '@/data/models/page.model';
import { currencyToNumber, numberMask } from '@/data/utils/helper';
import { cloneDeep } from 'lodash';

@Component({
	components: {
		ValidationObserver,
		ValidationProvider,
	},
})
export default class UtenteCallCenter extends Vue {
	@Prop() utente!: User;
	@Prop() editable!: boolean;
	@Prop({ default: false }) inModal!: boolean;

	@Inject('CrudService') userTimeCrudService!: CrudService<UserTime>;
	@Inject('CrudService') userConfCrudService!: CrudService<UserConf>;

	usertime!: UserTime;
	userconf!: UserConf;

	numberMask: any = numberMask();

	currencies: any = {};

	constructor() {
		super();
		this.usertime = new UserTime();
		this.usertime.userid = this.utente.id;
		this.userconf = new UserConf();
		this.userconf.userid = this.utente.id;
	}

	@Watch('utente', { immediate: true })
	onUserChange() {
		this.loadUserTime();
		this.loadUserConf();
	}

	loadUserTime() {
		const search = new Search('usertimeconf');
		search.addSimpleFilter('userid', this.utente.id);
		this.userTimeCrudService.searchEntities(UserTime, 'usertimeconf', search, new Page(1)).then(results => {
			if (results[0]) {
				this.usertime = results[0];
			}
		});
	}

	loadUserConf() {
		const search = new Search('userconf');
		search.addSimpleFilter('userid', this.utente.id);
		this.userConfCrudService.searchEntities(UserConf, 'userconf', search, new Page(1)).then(results => {
			if (results[0]) {
				this.userconf = results[0];
				this.setCurrency(this.userconf, 'revenueoffer');
			}
		});
	}

	onCurrencyChange(event: any, field: string) {
		this.currencies[field] = currencyToNumber(event.target._vCleave.getFormattedValue());
	}

	submit() {
		const uconf = cloneDeep(this.userconf);
		Object.keys(this.currencies).forEach(k => {
			this.$set(uconf, k, this.currencies[k]);
		});
		const requsertime = this.userTimeCrudService.createEntity(UserTime, 'usertimeconf', this.usertime);
		const requserconf = this.userConfCrudService.createEntity(UserConf, 'userconf', uconf);
		Promise.all([requsertime, requserconf]).then(results => {
			this.usertime = results[0];
			this.userconf = results[1];
			this.$buefy.notification.open({
				message: this.$t('success-save') as string,
				type: 'is-success',
			});
		}).catch(({ data }) => {
			this.$buefy.notification.open({
				message: data.msg || data.internal,
				type: 'is-danger',
			});
		});
	}

	private setCurrency(object: any, field: string) {
		const val = object[field];
		if (typeof val === 'undefined' || val === null) return;
		this.$set(object, field, val.toString().replace('.', ','));
	}
	
}
